import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { useControlsAndCapabilities } from '@/features/ctrls-and-caps/use-controls-and-capabilities'
import { getPlayerSession } from '@/features/player-session'

export const Route = createFileRoute('/_app')({
  component: function RouteComponent() {
    useControlsAndCapabilities()
    return <Outlet />
  },

  beforeLoad: async ({ location }) => {
    const playerSession = await getPlayerSession()

    if (playerSession.isUserLoggedIn) {
      return
    }
    if (playerSession.initializationError) {
      throw redirect({
        to: '/auth-server-unavailable',
        mask: { to: location.href },
      })
    }

    const targetUrl = window.location.origin + location.href

    await playerSession.login({
      redirectUrl: targetUrl,
      doesCurrentHrefRequiresAuth: window.location.href === targetUrl,
    })
  },
})
